(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("debug"), require("shortid"), require("ajv"));
	else if(typeof define === 'function' && define.amd)
		define("nqm-core-utils", ["_", "debug", "shortid", "ajv"], factory);
	else if(typeof exports === 'object')
		exports["nqm-core-utils"] = factory(require("lodash"), require("debug"), require("shortid"), require("ajv"));
	else
		root["nqm-core-utils"] = factory(root["_"], root["debug"], root["shortid"], root["ajv"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_14__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition